import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/Cafetera_andatti.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class CoffeMaker extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);
			this.Contenedor_5 = gltf.scene.getObjectByName("Contenedor_5", true); // R regular
			this.Contenedor_4 = gltf.scene.getObjectByName("Contenedor_4", true); // V Vainilla
			this.Contenedor_3 = gltf.scene.getObjectByName("Contenedor_3", true); // M Moka
			this.Contenedor_2 = gltf.scene.getObjectByName("Contenedor_2", true); // C Canela
			this.Contenedor_1 = gltf.scene.getObjectByName("Contenedor_1", true); // CH Chocolate
			this.Contenedor_5.renderOrder = 1;
			this.Contenedor_4.renderOrder = 1;
			this.Contenedor_3.renderOrder = 1;
			this.Contenedor_2.renderOrder = 1;
			this.Contenedor_1.renderOrder = 1;

			this.Codo_1 = gltf.scene.getObjectByName("Codo_1", true);
			this.Codo_2 = gltf.scene.getObjectByName("Codo_2", true);
			this.Codo_3 = gltf.scene.getObjectByName("Codo_3", true);
			this.Codo_4 = gltf.scene.getObjectByName("Codo_4", true);
			this.Codo_5 = gltf.scene.getObjectByName("Codo_5", true);
			this.Codo_1.renderOrder = 2;
			this.Codo_2.renderOrder = 2;
			this.Codo_3.renderOrder = 2;
			this.Codo_4.renderOrder = 2;
			this.Codo_5.renderOrder = 2;

			this.Surtidor_1 = gltf.scene.getObjectByName("Surtidor_1", true);
			this.Surtidor_2 = gltf.scene.getObjectByName("Surtidor_2", true);
			this.Surtidor_3 = gltf.scene.getObjectByName("Surtidor_3", true);
			this.Surtidor_4 = gltf.scene.getObjectByName("Surtidor_4", true);
			this.Surtidor_5 = gltf.scene.getObjectByName("Surtidor_5", true);
			this.Surtidor_1.renderOrder = 2;
			this.Surtidor_2.renderOrder = 2;
			this.Surtidor_3.renderOrder = 2;
			this.Surtidor_4.renderOrder = 2;
			this.Surtidor_5.renderOrder = 2;
		});
	}

	onEliminateScene() {
		if (this.animation) {
			this.Codo_1.material.color.set("#ffffff")
			this.animation.kill();
		}
		this.visible = false;
	}

	onCloneMaterialActPart2() {
		const newMaterial = this.Codo_1.material.clone();

		this.Codo_1.material = newMaterial
		this.Codo_2.material = newMaterial
		this.Codo_3.material = newMaterial
		this.Codo_4.material = newMaterial
		this.Codo_5.material = newMaterial

		this.Surtidor_1.material = newMaterial
		this.Surtidor_2.material = newMaterial
		this.Surtidor_3.material = newMaterial
		this.Surtidor_4.material = newMaterial
		this.Surtidor_5.material = newMaterial

		const colorInicial = { color: "#ffffff" }; // Color blanco

		this.animation = gsap.to(colorInicial, {
			color: "#F9E062",
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: 'power1.inOut',
			onUpdate: () => {
				this.Codo_1.material.color.set(colorInicial.color)
			},
		});

	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityOne.visibleCoffeMake, () => {
			this.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityOne.eliminateAnimation, (object) => {
			if (this.animation) {
				this.animation.kill();
			}

			if (object !== undefined) {
				if (this[object] !== undefined) {
					this[object].material.emissive = this.beforeColor;
				}
			}
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityTwo.animatePartCoffeMaker, (act = false) => {
			this.onCloneMaterialActPart2()
		});
	}

	onPosition(x = 0, y = 0, z = 0) {
		this.position.set(x, y, z);
	}

	clearAnimationContenedor() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null
			this.Contenedor_5.material.emissiveIntensity = 1;
			this.Contenedor_4.material.emissiveIntensity = 1;
			this.Contenedor_3.material.emissiveIntensity = 1;
			this.Contenedor_2.material.emissiveIntensity = 1;
			this.Contenedor_1.material.emissiveIntensity = 1;
		}
	}

	clearAnimationsCodo() {
		this.Codo_1.material.color.set("#fff")
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.Contenedor_5.material.emissiveIntensity = 1;
		this.Contenedor_4.material.emissiveIntensity = 1;
		this.Contenedor_3.material.emissiveIntensity = 1;
		this.Contenedor_2.material.emissiveIntensity = 1;
		this.Contenedor_1.material.emissiveIntensity = 1;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("CoffeMaker");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	renderAnimations() { }
}
